// @ts-ignore
import meManager from "../api/Me";
import {CellType, TableOrder} from "@/types";
import sottoProgettiManager from "../api/SottoProgetti";

const all_fields = [
    'ne_stato',
    'ne_tipologia',
    'ne_titolo',
    'ne_descrizione_servizio',
    'ne_voce_spesa',
    'ne_fornitore',
    'ac_costo_unitario',
    'ac_costo_unitario_e',
    'ac_unita',
    'ac_unita_descrizione',
    'ac_ovn_gg',
    'ac_ovn_gg_descrizione',
    'ac_qta',
    'ac_qta_descrizione',
    'ac_costo_unitario_risorsa_interna',
    'ac_costo_totale_risorsa_interna',
    'ac_commissione',
    'ac_totale_commissioni',
    'ac_costo_unitario_netto',
    'ac_costo_totale',
    'ac_costo_totale_e',
    'ac_valuta',
    'ac_aliquota',
    'ac_mark_up',
    'ac_arrotondamento_costo_unitario',
    'ac_note_interne',

    've_vendita_unitario',
    've_unita',
    've_unita_descrizione',
    've_ovn_gg',
    've_ovn_gg_descrizione',
    've_qta',
    've_qta_descrizione',
    // 've_costo_unitario_risorsa_interna',
    // 've_costo_totale_risorsa_interna',
    've_budget',
    've_budget_e',
    've_storico',
    've_valuta',
    've_aliquota',
    've_budget_lordo_iva',
    've_note',
    've_fee',
    're_mol',
    're_utile',
];

const BuFieldModule = {
    namespaced: true,
    state: () => ({
        all_fields,
        sottoProgettiCols: {
            ne_stato: {
                order_field: 'descrizione',
                prop: 'ne_stato',
                name: 'Stato',
                type: CellType.NE,
                class: '',
                orderable: true,
                resizable: true,
                td_class: '',
                width: null
            },
            ne_tipologia: {
                order_field: 'descrizione',
                prop: 'ne_tipologia',
                name: 'Tipologia',
                type: CellType.NE,
                class: '',
                orderable: true,
                resizable: true,
                td_class: '',
                width: null
            },
            ne_titolo: {
                prop: 'ne_titolo',
                name: 'Titolo',
                type: CellType.NE,
                class: '',
                orderable: false,
                resizable: true,
                td_class: '',
                width: null
            },
            ne_descrizione_servizio: {
                prop: 'ne_descrizione_servizio',
                name: 'Descrizione servizio',
                type: CellType.NE,
                class: '',
                orderable: true,
                resizable: true,
                td_class: '',
                width: null
            },
            ne_voce_spesa: {
                order_field: 'descrizione',
                prop: 'ne_voce_spesa',
                name: 'Voce di spesa',
                type: CellType.NE,
                class: 'min-w-200',
                orderable: true,
                resizable: true,
                width: null
            },
            ne_fornitore: {
                order_field: 'denominazione',
                prop: 'ne_fornitore',
                name: 'Fornitore',
                type: CellType.AC,
                class: 'min-w-200',
                orderable: true,
                resizable: true,
                td_class: '',
                width: null
            },
            ac_costo_unitario: {
                prop: 'ac_costo_unitario',
                name: 'Costo unitario',
                type: CellType.AC,
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_costo_unitario_e: {
                prop: 'ac_costo_unitario_e',
                name: 'Costo unitario €',
                type: CellType.AC,
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_unita: {
                prop: 'ac_unita',
                name: 'Qtà 1',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_unita_descrizione: {
                prop: 'ac_unita_descrizione',
                name: 'Qtà 1 descrizione',
                type: CellType.AC,
                class: '',
                orderable: false,
                resizable: true,
                width: null
            },
            ac_ovn_gg: {
                prop: 'ac_ovn_gg',
                name: 'Qtà 2',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_ovn_gg_descrizione: {
                prop: 'ac_ovn_gg_descrizione',
                name: 'Qtà 2 descrizione',
                type: CellType.AC,
                class: '',
                orderable: false,
                resizable: true,
                width: null
            },
            ac_qta: {
                prop: 'ac_qta',
                name: 'Qtà 3',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_qta_descrizione: {
                prop: 'ac_qta_descrizione',
                name: 'Qtà 3 descrizione',
                type: CellType.AC,
                class: '',
                orderable: false,
                resizable: true,
                width: null
            },
            ac_costo_unitario_risorsa_interna: {
                prop: 'ac_costo_unitario_risorsa_interna',
                name: 'Costo unitario risorsa',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_costo_totale_risorsa_interna: {
                prop: 'ac_costo_totale_risorsa_interna',
                name: 'Costo totale risorsa',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_commissione: {
                prop: 'ac_commissione',
                name: 'Commiss. %',
                type: CellType.AC,
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_totale_commissioni: {
                prop: 'ac_totale_commissioni',
                name: 'Tot. Commiss.',
                type: CellType.AC,
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_costo_unitario_netto: {
                prop: 'ac_costo_unitario_netto',
                name: 'Costo unitario netto',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_costo_totale: {
                prop: 'ac_costo_totale',
                name: 'Costo totale',
                type: CellType.AC,
                class: '',
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_costo_totale_e: {
                prop: 'ac_costo_totale_e',
                name: 'Costo totale €',
                type: CellType.AC,
                class: '',
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_valuta: {
                prop: 'ac_valuta',
                name: 'Valuta acquisto',
                type: CellType.AC,
                class: 'min-w-200',
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_aliquota: {
                order_field: 'valore',
                prop: 'ac_aliquota',
                name: 'IVA acquisto',
                type: CellType.AC,
                class: 'w-32',
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_mark_up: {
                prop: 'ac_mark_up',
                name: 'Mark Up',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_arrotondamento_costo_unitario: {
                prop: 'ac_arrotondamento_costo_unitario',
                name: 'Arr. cst. unt.',
                type: CellType.AC,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ac_note_interne: {
                prop: 'ac_note_interne',
                name: 'Note interne',
                type: CellType.AC,
                class: 'min-w-300',
                td_class: '',
                orderable: false,
                resizable: true,
            },
            ve_vendita_unitario: {
                prop: 've_vendita_unitario',
                name: 'Prezzo unitario',
                type: CellType.VE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_unita: {
                prop: 've_unita',
                name: 'Qtà 1',
                type: CellType.VE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_unita_descrizione: {
                prop: 've_unita_descrizione',
                name: 'Qtà 1 descrizione',
                type: CellType.VE,
                class: '',
                orderable: false,
                resizable: true,
                width: null
            },
            ve_ovn_gg: {
                prop: 've_ovn_gg',
                name: 'Qtà 2',
                type: CellType.VE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_ovn_gg_descrizione: {
                prop: 've_ovn_gg_descrizione',
                name: 'Qtà 2 descrizione',
                type: CellType.VE,
                class: '',
                orderable: false,
                resizable: true,
                width: null
            },
            ve_qta: {
                prop: 've_qta',
                name: 'Qtà 3',
                type: CellType.VE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_qta_descrizione: {
                prop: 've_qta_descrizione',
                name: 'Qtà 3 descrizione',
                type: CellType.VE,
                class: '',
                orderable: false,
                resizable: true,
                width: null
            },
            // ve_costo_unitario_risorsa_interna: {
            //     prop: 've_costo_unitario_risorsa_interna',
            //     name: 'Costo unitario risorsa',
            //     type: CellType.VE,
            //     class: '',
            //     orderable: true,
            //     resizable: true,
            //     width: null
            // },
            // ve_costo_totale_risorsa_interna: {
            //     prop: 've_costo_totale_risorsa_interna',
            //     name: 'Costo totale risorsa',
            //     type: CellType.VE,
            //     class: '',
            //     orderable: false,
            //     resizable: true,
            //     width: null
            // },
            ve_budget: {
                prop: 've_budget',
                name: 'Budget imp.',
                type: CellType.VE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_budget_e: {
                prop: 've_budget_e',
                name: 'Budget. imp. €',
                type: CellType.VE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_storico: {
                prop: 've_storico',
                name: 'Storico vendite',
                type: CellType.NE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_valuta: {
                prop: 've_valuta',
                name: 'Valuta vendita',
                type: CellType.VE,
                class: 'min-w-200',
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_aliquota: {
                prop: 've_aliquota',
                name: 'IVA vendita',
                type: CellType.VE,
                class: 'w-32',
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_budget_lordo_iva: {
                prop: 've_budget_lordo_iva',
                name: 'Budget lordo IVA',
                type: CellType.VE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            ve_note: {
                prop: 've_note',
                name: 'Note',
                type: CellType.VE,
                class: 'min-w-300',
                td_class: '',
                orderable: false,
                resizable: true,
                width: null
            },
            ve_fee: {
                prop: 've_fee',
                name: 'Fee',
                type: CellType.RE,
                class: 'min-w-180',
                td_class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            re_mol: {
                prop: 're_mol',
                name: 'Primo Margine %',
                type: CellType.RE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
            re_utile: {
                prop: 're_utile',
                name: 'Primo Margine',
                type: CellType.RE,
                class: '',
                orderable: true,
                resizable: true,
                width: null
            },
        },
        userPreference: [],
        computedUserPreference: [],
        valute: []
    }),
    mutations: {

        setAllVisible(state: any) {
            const obj: any[] = []
            for (const i in state.sottoProgettiCols) {
                obj.push({...state.sottoProgettiCols[i], visible: true, order: TableOrder.NONE})
            }
            state.computedUserPreference = obj
        },
        setVenditaHidden(state: any) {
            const obj: any[] = []
            for (const i in state.sottoProgettiCols) {
                if (state.sottoProgettiCols[i].type == CellType.VE) {
                    obj.push({...state.sottoProgettiCols[i], visible: false, order: TableOrder.NONE})
                } else {
                    obj.push({...state.sottoProgettiCols[i], visible: true, order: TableOrder.NONE})
                }
            }
            state.computedUserPreference = obj
        },
        setAcquistoHidden(state: any) {
            const obj: any[] = []
            for (const i in state.sottoProgettiCols) {
                if (state.sottoProgettiCols[i].type == CellType.AC) {
                    obj.push({...state.sottoProgettiCols[i], visible: false, order: TableOrder.NONE})
                } else {
                    obj.push({...state.sottoProgettiCols[i], visible: true, order: TableOrder.NONE})
                }
            }
            state.computedUserPreference = obj
        },
        setUserPreference(state: any, up: any) {
            state.userPreference = up
            const obj: any[] = []
            state.userPreference.forEach((el: any) => {
                obj.push({
                    ...state.sottoProgettiCols[el.prop],
                    visible: el.visible,
                    order: TableOrder.NONE,
                    width: el.width
                })
            })
            state.computedUserPreference = obj
        },
        toggleFieldVisibility(state: any, prop: string) {
            const index = state.computedUserPreference.findIndex((el: any) => {
                return el.prop == prop
            })
            if (index > -1) {
                state.computedUserPreference[index].visible = !state.computedUserPreference[index].visible
            }
        },
        orderChange(state: any, prop: string) {
            state.computedUserPreference.forEach((el: any) => {
                if (el.prop != prop) {
                    el.order = TableOrder.NONE
                }
            })
            const index = state.computedUserPreference.findIndex((el: any) => {
                return el.prop == prop
            })
            if (index > -1) {
                const el = state.computedUserPreference[index]
                switch (el['order']) {
                    case TableOrder.NONE:
                        el['order'] = TableOrder.ASC
                        break;
                    case TableOrder.ASC:
                        el['order'] = TableOrder.DESC
                        break;
                    case TableOrder.DESC:
                        el['order'] = TableOrder.NONE
                        break;
                }
            }
        }
    },
    actions: {
        //@ts-ignore
        setAllVisible({commit}) {
            commit('setAllVisible')
        },
        //@ts-ignore
        setVenditaHidden({commit}) {
            commit('setVenditaHidden')
        },
        //@ts-ignore
        setAcquistoHidden({commit}) {
            commit('setAcquistoHidden')
        },
        //@ts-ignore
        fetchSottoprogettoUserPreference({commit, state, rootState}, sp_id) {
            meManager.sottoprogettoPreference(sp_id).then((res) => {
                commit('setUserPreference', JSON.parse(res.data.data))
            }).catch(() => {
                sottoProgettiManager.defaultConf(sp_id).then((res) => {
                    const conf = JSON.parse(res.data)
                    commit('setUserPreference', state['all_fields'].sort((a:any,b:any)=>{
                        return conf.findIndex((e:any)=>{return e[0] == a}) - conf.findIndex((e:any)=>{return e[0] == b})
                    }).map((el: string) => {
                        const ee = conf.find((e:any)=>{return e[0] == el})
                        return {
                            prop: state.sottoProgettiCols[el].prop,
                            visible: ee ? ee[1] : false,
                            order: TableOrder.NONE
                        }
                    }))
                }).catch(() => {
                    commit('setUserPreference', state['all_fields'].map((el: string) => {
                        return {prop: state.sottoProgettiCols[el].prop, visible: true, order: TableOrder.NONE}
                    }))
                })
            })
        },
        //@ts-ignore
        updateTableHeader({commit}, cols) {
            commit('setUserPreference', cols)
        },
        //@ts-ignore
        toggleFieldVisibility({commit}, col_prop) {
            commit('toggleFieldVisibility', col_prop)
        },
        //@ts-ignore
        orderChange({commit}, col_prop) {
            commit('orderChange', col_prop)
        },

    },
    getters: {
        cellsDescriptor: (state: any) => {
            return state.sottoProgettiCols
        },
        isCellAcquisto: () => (celltype: number) => {
            return celltype == CellType.AC
        },
        isCellVendita: () => (celltype: number) => {
            return celltype == CellType.VE
        },
        isCellRe: () => (celltype: number) => {
            return celltype == CellType.RE
        },
        isCellNe: () => (celltype: number) => {
            return celltype == CellType.NE
        },
        getValuta: (state: any) => (id: string) => {
            return state.valute.find((el: any) => el.id == id)
        },
        allField(state: any) {
            return state.all_fields
        },
        sortedAllField(state: any) {
            return state.all_fields
        },
        computedUserPreference(state: any) {
            return state.computedUserPreference
        },
        AcComputedUserPreference(state: any, getters: any) {
            return state.computedUserPreference.filter((el: any) => {
                return getters.isCellAcquisto(el.type)
            })
        },
        VeComputedUserPreference(state: any, getters: any) {
            return state.computedUserPreference.filter((el: any) => {
                return getters.isCellVendita(el.type)
            })
        },
        ReComputedUserPreference(state: any, getters: any) {
            return state.computedUserPreference.filter((el: any) => {
                return getters.isCellRe(el.type)
            })
        },
        NeComputedUserPreference(state: any, getters: any) {
            return state.computedUserPreference.filter((el: any) => {
                return getters.isCellNe(el.type)
            })
        },
        tableHeader(state: any) {
            return state.computedUserPreference
        },
        OrderedRows: (state: any, getters: any, rootState: any, rootGetters: any) => (rows: any[]) => {
            const field_to_order = state.computedUserPreference.findIndex((el: any) => el.order != TableOrder.NONE && el.orderable)
            if (field_to_order > -1 && state.computedUserPreference[field_to_order]['order'] != TableOrder.NONE) {
                const field = state.computedUserPreference[field_to_order];
                const order_field = field.order_field
                const prop = field.prop;
                //serve una copia altrimenti viene triggerato il salvataggio perché il sort ordina l'array originario
                const sorted_rows = [...rows].sort(function (a, b) {
                    let aa = a[prop];
                    let bb = b[prop];

                    if (order_field) {
                        //se è una select allora prendo il valore text
                        if (aa && bb && Object.prototype.hasOwnProperty.call(aa, order_field) && Object.prototype.hasOwnProperty.call(bb, order_field)) {
                            aa = a[prop][order_field];
                            bb = b[prop][order_field];
                        }
                    } else{
                        //se è un campo calcolato allora vado a prendere il getter relativo
                        switch (prop) {
                            case 've_vendita_unitario':
                                aa = rootGetters["sprjDataManager/CostoVenditaUnitario"](a)
                                bb = rootGetters["sprjDataManager/CostoVenditaUnitario"](b)
                                break
                            case 've_budget_e':
                                aa = rootGetters["sprjDataManager/VeBudgetEuro"](a)
                                bb = rootGetters["sprjDataManager/VeBudgetEuro"](b)
                                console.log(aa,bb)
                                break
                            case 'ac_costo_unitario_e':
                                aa = rootGetters["sprjDataManager/AcCostoUnitarioEuro"](a)
                                bb = rootGetters["sprjDataManager/AcCostoUnitarioEuro"](b)
                                break
                            case 'ac_costo_totale_e':
                                aa = rootGetters["sprjDataManager/AcCostoTotaleEuro"](a)
                                bb = rootGetters["sprjDataManager/AcCostoTotaleEuro"](b)
                                break
                            case 'ac_totale_commissioni':
                                aa = rootGetters["sprjDataManager/AcCommissioneTotale"](a)
                                bb = rootGetters["sprjDataManager/AcCommissioneTotale"](b)
                                break
                            case 'ac_costo_totale_risorsa_interna':
                                aa = rootGetters["sprjDataManager/AcCostoTotaleRisorsa"](a)
                                bb = rootGetters["sprjDataManager/AcCostoTotaleRisorsa"](b)
                                break
                            case 'ac_costo_unitario_netto':
                                aa = rootGetters["sprjDataManager/AcCostoUnitarioNetto"](a)
                                bb = rootGetters["sprjDataManager/AcCostoUnitarioNetto"](b)
                                break
                            case 'ac_costo_totale':
                                aa = rootGetters["sprjDataManager/AcCostoTotale"](a)
                                bb = rootGetters["sprjDataManager/AcCostoTotale"](b)
                                break
                            case 've_budget':
                                aa = rootGetters["sprjDataManager/VeBudget"](a)
                                bb = rootGetters["sprjDataManager/VeBudget"](b)
                                break
                            case 've_budget_lordo_iva':
                                aa = rootGetters["sprjDataManager/BudgetLordoIva"](a)
                                bb = rootGetters["sprjDataManager/BudgetLordoIva"](b)
                                break
                            case 're_utile':
                                aa = rootGetters["sprjDataManager/Utile"](a)
                                bb = rootGetters["sprjDataManager/Utile"](b)
                                break
                            case 're_mol':
                                aa = rootGetters["sprjDataManager/Mol"](a)
                                bb = rootGetters["sprjDataManager/Mol"](b)
                                break
                        }
                    }
                    if ((typeof aa) == (typeof bb) && (typeof bb) == 'number') {
                        switch (state.computedUserPreference[field_to_order]['order']) {
                            case TableOrder.ASC:
                                return aa - bb
                            case TableOrder.DESC:
                                return bb - aa
                            default:
                                return 0
                        }
                    }
                    switch (state.computedUserPreference[field_to_order]['order']) {
                        case TableOrder.ASC:
                            return ('' + aa).localeCompare(bb);
                        case TableOrder.DESC:
                            return ('' + bb).localeCompare(aa);
                        default:
                            return 0
                    }
                })
                let all_sorted_rows: any[] = []
                sorted_rows.forEach((row) => {
                    all_sorted_rows.push(row)
                    if (row.nuvole || row.alternative) {
                        const sorted_subrows = getters.OrderedRows(row.nuvole || row.alternative)
                        all_sorted_rows = all_sorted_rows.concat(sorted_subrows)
                    }
                })
                return all_sorted_rows
            }
            let all_sorted_rows: any[] = []
            rows.forEach((row) => {
                all_sorted_rows.push(row)
                if (row.nuvole || row.alternative) {
                    all_sorted_rows = all_sorted_rows.concat(row.nuvole || row.alternative)
                }
            })
            return all_sorted_rows
        }
    }
}

export default BuFieldModule;
